import axios from "axios";

const api = axios.create({
    baseURL: "https://viaglobal.pl/api/",
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
    withCredentials: true, // Required for Sanctum
});

api.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("token")}`; // Default token in headers


export default api;